import axios from "axios";
const API_KEY = process.env.REACT_APP_API_KEY;

export async function handleRequest(url, objectData, token) {
  try {
    const headers = {
      "api-key": API_KEY,
      recaptcha: token,
      conference: "ots2026",
    };
    return await axios.post(url, objectData, { headers });
  } catch (error) {
    throw new Error(error);
  }
}
